
import PictureInput from 'vue-picture-input';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { CountryFindAll } from '@/settings/application/uses_cases/country/search/CountryFindAll';
import { CurrencyFindAll } from '@/settings/application/uses_cases/currency/search/CurrencyFindAll';
import { StateFindByCountryCode } from '@/settings/application/uses_cases/state/search/StateFindByCountryCode';
import { StateFindAll } from '@/settings/application/uses_cases/state/search/StateFindAll';
import { ZoneFindByStatusAndCountryAndState } from '@/settings/application/uses_cases/zone/search/ZoneFindByStatusAndCountryAndState';
import { FileFindAll } from '@/settings/application/uses_cases/file/search/FileFindAll';
import { ValidationObserver } from 'vee-validate/dist/types/components';
import { CreateFile } from '@/settings/application/uses_cases/file/create/CreateFile';
import { CreateCompany } from '@/settings/application/uses_cases/company/create/CreateCompany';
import { CompanyUpdate } from '@/settings/application/uses_cases/company/update/CompanyUpdate';
import { CompanyFindById } from '@/settings/application/uses_cases/company/search/CompanyFindById';
import i18n from '@/core/plugins/i18n';
import { MigrationFromCountryCode } from '@/settings/application/uses_cases/migration/MigrationFromCountryCode';
import { showAlert } from '@/core/plugins/Notifications';
import { Territories } from '@/settings/domain/views/territories/Territories';
import { SearchTerritoryByQueryDescription } from '@/settings/application/uses_cases/views/territories/SearchTerritoryByQueryDescription';
import SearchTerritories from '@/core/components/shared/SearchTerritories.vue';
import Draggable from 'vuedraggable';
import { PricingZone } from '@/settings/domain/PricingZone/PricingZone';
import { PricingZoneFindAll } from '@/settings/application/uses_cases/PricingZone/search/PricingZoneFindAll';

@Component({
  name: 'CompanySettings',
  components: {
    PictureInput,
    SearchTerritories,
    Draggable
  }
})
export default class CompanySettings extends Vue {
  $refs!: {
    wizard: HTMLFormElement;
    formWizardOrder: HTMLFormElement;
    companyId: HTMLFormElement;
    companyDni: HTMLFontElement;
    firstStep: InstanceType<typeof ValidationObserver>;
    twoStep: InstanceType<typeof ValidationObserver>;
    pictureInput: HTMLFormElement;
    fileInput: HTMLFormElement;
    companyAddress: HTMLFormElement;
    companyName: HTMLFormElement;
    companyPhone: HTMLFormElement;
    companyEmail: HTMLFormElement;
    companyCodePostal: HTMLFormElement;
    companyprofitending: HTMLFormElement;
    companyclosingperiod: HTMLFormElement;
    companylocalcurrency: HTMLFormElement;
  };
  @Inject(TYPES.FINDALL_COUNTRY)
  readonly countryFindAllcall!: CountryFindAll;
  @Inject(TYPES.FINDALL_CURRENCY)
  readonly currencyFindAllcall!: CurrencyFindAll;
  @Inject(TYPES.FINDBYCOUNTRYCODE_STATE)
  readonly stateFindByCountryCode!: StateFindByCountryCode;
  @Inject(TYPES.FINDALL_STATE)
  readonly stateFindAllcall!: StateFindAll;
  @Inject(TYPES.FINDSTATUSCOUNTRYSTATE_ZONE)
  readonly zoneFindByStatusAndCountryAndState!: ZoneFindByStatusAndCountryAndState;
  @Inject(TYPES.FINDALL_COMPANY)
  readonly CompanyFindAllcall!: CompanyFindById;
  @Inject(TYPES.CREATE_COMPANY)
  readonly createCompany!: CreateCompany;
  @Inject(TYPES.UPDATE_COMPANY)
  readonly companyUpdate!: CompanyUpdate;
  @Inject(TYPES.FINDBYID_COMPANY)
  readonly companyFindById!: CompanyFindById;
  @Inject(TYPES.FINDALL_FILE)
  readonly fileFindAll!: FileFindAll;
  @Inject(TYPES.CREATE_FILE)
  readonly createFile!: CreateFile;
  @Inject(TYPES.MIGRATIONS_FROMCOUNTRYCODE)
  readonly migrations!: MigrationFromCountryCode;
  @Inject(TYPES.API_VIEW_FIND_TERRITORIES_BY_QUERY)
  readonly searchTerritoriesByQueryParameter!: SearchTerritoryByQueryDescription;
  @Inject(TYPES.PRICING_ZONE_FIND_ALL)
  readonly findAllPricingZones!: PricingZoneFindAll;

  target = i18n.t('general.company');
  isLoading = false;
  fullPage = true;
  countries = [];
  nameCurrencies = [];
  provinces = [];
  disabled = true;
  isDisabled = false;
  isTouched = false;
  isSave = false;
  optionshierarchy: any = [
    { label: this.$t('general.supplier'), code: 'supplier' },
    { label: this.$t('general.pricingZone'), code: 'zone' },
    { label: this.$t('general.customer'), code: 'customer' }
  ];
  zoneCompany = [] as any;
  file: any = null;
  fileStatus = false;
  base64Pdf = '';
  fileName = '';
  fileNameBoolean = true;
  countryCode = '';
  zonesList: PricingZone[] = [];
  form: any = {
    companyId: '',
    companyDni: '',
    companyName: '',
    companyAddress: '',
    companyPhone: '',
    companyEmail: '',
    companyPassword: 'empty',
    companyRePassword: 'empty',
    companyCity: 'empty',
    companyState: [],
    companyCountry: [],
    companyCodePostal: [],
    companyEarningAccounts: '',
    companyprofitending: '',
    companylocalcurrency: [],
    companyTransactionalCurrency: [],
    companypercentprofitability: '',
    country: '',
    countryDescription: '',
    state: '',
    stateDescription: '',
    zipCode: '',
    zipCodeDescription: '',
    address: '',
    controlprofitability: false,
    edi: false,
    expirationlock: false,
    ean13: false,
    courier: false,
    freight: false,
    wms: false,
    tracking: false,
    amazonstore: false,
    multicurrency: false,
    orderlock: false,
    quotelock: false,
    useserial: false,
    usezone: false,
    virtualLocker: false,
    purchasesinshipments: false,
    companyclosingperiod: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
    dropCompanySetting: '',
    urlImage: '',
    urlPdf: '',
    urlBase64Logo: '',
    image: '',
    origin: null,
    zoneZcOrigin: '',
    priorityPrice1: '',
    priorityPrice2: '',
    priorityPrice3: '',
    zonePricingLevel: ''
  };

  operationalProfilesStore = JSON.parse(localStorage.getItem('operationalProfiles') as any);
  operationalProfilesSelected: any[] = [];

  origin: Territories[] = [];
  mounted() {
    this.findByIdCompany();
    this.findPricingZones();
  }
  created() {
    this.$nextTick(() => this.currencyFindAll());
    this.$nextTick(() => this.countryFindAll());
  }

  get disablePricingLevel() {
    return this.zonesList.length > 0;
  }

  get zonePricingOptions() {
    return [
      {
        text: `${this.$t('general.country')}`,
        value: 'country'
      },
      {
        text: `${this.$t('general.state')}`,
        value: 'state'
      },
      {
        text: `${this.$t('general.city')}`,
        value: 'city'
      }
    ];
  }

  get operationalProfiles() {
    const arrayProfile = [
      {
        text: 'wms',
        value: 'w',
        notEnabled: true
      },
      {
        text: 'courier',
        value: 'u',
        notEnabled: true
      },
      {
        text: 'tracking',
        value: 'c',
        notEnabled: true
      }
    ] as any;

    arrayProfile.map((item: any) => {
      if (this.operationalProfilesStore.find((element: any) => element == item.text)) {
        item.text =
          item.text == 'wms'
            ? this.$t('general.WMS')
            : item.text == 'courier'
            ? this.$t('menu.Courier')
            : item.text == 'tracking'
            ? this.$t('menu.Freight')
            : '';

        this.operationalProfilesSelected.push(
          item.text == this.$t('general.WMS')
            ? 'w'
            : item.text == this.$t('menu.Courier')
            ? 'u'
            : item.text == this.$t('menu.Freight')
            ? 'c'
            : ''
        );
      }
    });
    return arrayProfile;
  }

  //METHODS
  findTerritriesFromView(query: string) {
    if (query.length >= 3) {
      this.isLoading = true;
      this.searchTerritoriesByQueryParameter
        .execute(query.toUpperCase())
        .then((response: any) => {
          this.isLoading = false;
          this.origin = response;
        })
        .catch(error => {
          this.isLoading = false;
          this.origin = [];
          throw new Error(`${error}`);
        });
    }
  }

  countryFindAll() {
    this.countryFindAllcall
      .execute()
      .then((response: any) => {
        this.countries = response;
      })
      .catch((error: any) => {
        throw new Error(error);
      });
  }
  currencyFindAll() {
    this.currencyFindAllcall
      .execute()
      .then((response: any) => {
        this.nameCurrencies = response;
      })
      .catch((error: any) => {
        throw new Error(error);
      });
  }
  async zoneByCountryAndStateFromCall(countryFrom: any, stateFrom: any) {
    if (countryFrom.code != null && stateFrom.code != null) {
      this.form.companyCodePostal = [];
      this.zoneCompany = [];
      const payload: any = {
        country: countryFrom.code,
        state: stateFrom.code,
        status: true
      };
      await this.zoneFindByStatusAndCountryAndState
        .execute(payload)
        .then((response: any) => {
          this.zoneCompany = response;
          this.zoneCompany.unshift('');
        })
        .catch(() => {
          this.zoneCompany = [];
        });
    }
  }
  async stateFindByCountryCodeCall(country: any) {
    if (country.code) {
      this.form.companyState = [];
      this.form.companyCodePostal = [];
      await this.stateFindByCountryCode
        .execute(country.code)
        .then((response: any) => {
          this.provinces = response;
        })
        .catch((error: any) => {
          throw new Error(error);
        });
    } else {
      this.form.companyState = [];
    }
  }
  stateFindAll() {
    this.stateFindAllcall
      .execute()
      .then((response: any) => {
        this.provinces = response;
      })
      .catch((error: any) => {
        throw new Error(error);
      });
  }
  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }
  isLastStep() {
    if (this.$refs.wizard) {
      return this.$refs.wizard.isLastStep;
    }
    return false;
  }
  async findByIdCompany() {
    this.isLoading = true;
    const companyId = localStorage.getItem('businessId') as string;
    await this.companyFindById
      .internalExecute(companyId)
      .then((response: any) => {
        this.isSave = true;
        this.form.companyId = response['id'];
        this.form.companyDni = response['dni'];
        this.form.companyName = response['businessName'];
        //Address
        if (response['country'] != null && response['state'] != null) {
          this.form.companyAddress = response.address;
          this.form.origin = {
            city: response.city,
            cityName: response.cityDescription,
            country: response.country,
            countryName: response.countryDescription,
            state: response.state,
            stateName: response.stateDescription,
            fullName: response.countryDescription + ' - ' + response.stateDescription + ' - ' + response.cityDescription
          };

          this.form.companyCountry = {
            name: response['countryDescription'],
            code: response['country']
          };
          this.stateFindByCountryCodeCall(this.form.companyCountry);
          this.form.companyState = {
            name: response['stateDescription'],
            code: response['state']
          };
          if (response['zipCode'] != null) {
            this.zoneByCountryAndStateFromCall(this.form.companyCountry, this.form.companyState);
            this.form.companyCodePostal = {
              zoneZc: response['zipCode'],
              description: response['zipCodeDescription']
            };
          }
        }
        //Others data
        this.form.companyPhone = response['phoneNumber'];
        this.form.companyEmail = response['email'];
        this.form.companyEarningAccounts = response['earningAccounts'];
        this.form.companyprofitending = response['profitEnding'];
        this.form.companylocalcurrency = {
          currencyCode: response['localCurrency'],
          description: response['localCurrencyName']
        };
        this.form.companyTransactionalCurrency = {
          currencyCode: response['defaultCurrency'],
          description: response['defaultCurrencyName']
        };
        this.form.companypercentprofitability = response['percentProfitability'];
        this.form.companyclosingperiod = response['year'] + '-' + response['month'];
        this.form.controlprofitability = response['controlProfitability'];
        this.form.edi = response['edi'];
        this.form.expirationlock = response['expirationLock'];
        this.form.ean13 = response['ean13'];
        this.form.courier = response['isCourier'];
        this.form.freight = response['isFreight'];
        this.form.wms = response['isWms'];
        this.form.multicurrency = response['multiCurrency'];
        this.form.orderlock = response['orderLock'];
        this.form.quotelock = response['quoteLock'];
        this.form.useserial = response['serial'];
        this.form.usezone = response['zoneZc'];
        this.form.amazonstore = response['amazonStore'];
        this.form.tracking = response['tracking'];
        this.form.virtualLocker = response['virtualLocker'];
        this.form.purchasesinshipments = response['handlePurchase'];
        this.form.dropCompanySetting = '/assets/img/circle_logo.png';
        this.form.urlImage = response['urlLogo'];
        this.fileName = response['urlPdf'];
        this.form.zonePricingLevel = response['zonePricingLevel'];
        this.form.zoneZcOrigin = response['zipCode'];
        this.optionshierarchy = [];
        this.optionshierarchy.push({
          label: this.$t(
            `general.${response['priorityPrice1'] == 'zone' ? 'pricingZone' : response['priorityPrice1']}`
          ),
          code: response['priorityPrice1']
        });
        this.optionshierarchy.push({
          label: this.$t(
            `general.${response['priorityPrice2'] == 'zone' ? 'pricingZone' : response['priorityPrice2']}`
          ),
          code: response['priorityPrice2']
        });
        this.optionshierarchy.push({
          label: this.$t(
            `general.${response['priorityPrice3'] == 'zone' ? 'pricingZone' : response['priorityPrice3']}`
          ),
          code: response['priorityPrice3']
        });
        this.fileFindAll
          .execute(this.form.urlImage.replace('file/getImageAsByteArray?name=', response['urlLogo']))
          .then((resp: any) => {
            this.isLoading = false;
            this.form.urlBase64Logo = resp['base64'];
          })
          .catch((error: any) => {
            this.isLoading = false;
            throw new Error(error);
          });
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  onChanged() {
    if (this.$refs.pictureInput.file) {
      this.form.image = this.$refs.pictureInput.file;
    }
  }
  async registerCompany() {
    if (this.form.image) {
      const payloadImg: any = {
        contentType: this.$refs.pictureInput.file.type,
        name: '',
        size: this.$refs.pictureInput.file.size,
        base64: this.$refs.pictureInput.image
      };
      const extension = this.$refs.pictureInput.file.name.split('.').pop();
      payloadImg.name = this.form.companyId.trim() + '.' + extension;
      this.form.urlImage = this.form.companyId.trim() + '.' + extension;
      this.createFile.execute(payloadImg);
    } else if (this.$refs.pictureInput.image === '') {
      this.form.urlImage = '';
    }
    let nameFile: any;
    if (this.file !== null) {
      let arrayPdf: any = {};
      await this.getBase64(this.$refs.fileInput.files[0]).then((response: any) => {
        arrayPdf = { base64: response };
      });
      const payloadPdf: any = {
        contentType: this.$refs.fileInput.files[0].type,
        name: '',
        size: this.$refs.fileInput.files[0].size,
        base64: ''
      };
      nameFile = this.file['name'].split('.').pop();
      payloadPdf.base64 = arrayPdf.base64;
      payloadPdf.name = this.form.companyId.trim() + '.' + nameFile;
      this.createFile.execute(payloadPdf);
    } else {
      this.file = null;
    }

    const payload: any = {
      id: this.form.companyId,
      dni: this.form.companyDni,
      businessName: this.form.companyName,
      country: this.form.origin.country ? this.form.origin.country : null,
      countryDescription: this.form.origin.countryName ? this.form.origin.countryName : null,
      state: this.form.origin.state ? this.form.origin.state : null,
      stateDescription: this.form.origin.stateName ? this.form.origin.stateName : null,
      city: this.form.origin.city ? this.form.origin.city : null,
      cityDescription: this.form.origin.cityName ? this.form.origin.cityName : null,
      zipCode: this.form.zoneZcOrigin,
      zipCodeDescription: this.form.zoneZcOrigin,
      address: this.form.companyAddress,
      phoneNumber: this.form.companyPhone,
      email: this.form.companyEmail,
      earningAccounts: this.form.companyEarningAccounts,
      profitEnding: this.form.companyprofitending,
      localCurrency: this.form.companylocalcurrency.currencyCode,
      localCurrencyName: this.form.companylocalcurrency.description,
      defaultCurrency: this.form.companyTransactionalCurrency.currencyCode,
      defaultCurrencyName: this.form.companyTransactionalCurrency.description,
      percentProfitability: this.form.companypercentprofitability,
      year: this.form.companyclosingperiod.substring(0, 4),
      month: this.form.companyclosingperiod.substring(5, 7),
      controlProfitability: this.form.controlprofitability,
      edi: this.form.edi,
      expirationLock: this.form.expirationlock,
      ean13: this.form.ean13,
      isCourier: this.form.courier,
      isFreight: this.form.freight,
      isWms: this.form.wms,
      multiCurrency: this.form.multicurrency,
      orderLock: this.form.orderlock,
      quoteLock: this.form.quotelock,
      serial: this.form.useserial,
      zoneZc: this.form.usezone,
      tracking: this.form.tracking,
      amazonStore: this.form.amazonstore,
      password: this.form.companyPassword,
      virtualLocker: this.form.virtualLocker,
      handlePurchase: this.form.purchasesinshipments,
      urlLogo: this.form.urlImage,
      urlPdf: '',
      priorityPrice1: this.optionshierarchy[0].code,
      priorityPrice2: this.optionshierarchy[1].code,
      priorityPrice3: this.optionshierarchy[2].code,
      zonePricingLevel: this.form.zonePricingLevel
    };
    if (nameFile != null) {
      payload.urlPdf = this.form.companyId.trim() + '.' + nameFile;
    }

    if (!this.isSave) {
      this.isLoading = true;
      this.createCompany
        .execute(payload)
        .then(() => {
          this.isLoading = false;
          this.clearForm();
          this.findByIdCompany();
          this.$refs.formWizardOrder.reset();
        })
        .catch((error: any) => {
          this.isLoading = false;
          throw new Error(error);
        });
    } else {
      if (this.file && this.$refs.fileInput.files[0].type != 'application/pdf') {
        this.fileStatus = true;
      } else {
        this.fileStatus = false;
        this.isLoading = true;
        this.companyUpdate
          .execute(payload)
          .then(() => {
            this.isLoading = false;
            this.$refs.formWizardOrder.reset();
            this.findByIdCompany();
          })
          .catch((error: any) => {
            this.isLoading = false;
            throw new Error(error);
          });
      }
    }
  }
  onRemoved() {
    this.form.image = '';
  }
  onTouch() {
    this.isTouched = true;
  }
  currencyWithRate({ currencyCode, description }: any) {
    return `${currencyCode} — [${description}]`;
  }
  validateStepOne() {
    if (this.form.origin == null) {
      this.$swal({
        title: `${this.$t('general.warning')}`,
        text: `${this.$t('general.noOriginSelected')}`,
        icon: 'warning'
      });
      return false;
    }
    return this.$refs.firstStep.validate();
  }
  validateStepTwo() {
    return this.$refs.twoStep.validate();
  }
  descriptionCurrency(currencyCode: any) {
    let name;
    let currency: any;
    for (currency of this.nameCurrencies) {
      if (currency.currencyCode === currencyCode) {
        name = currency.description;
      }
    }
    return name;
  }
  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  clearForm() {
    this.form.companyId = '';
    this.form.companyDni = '';
    this.form.companyName = '';
    this.form.companyAddress = '';
    this.form.companyPhone = '';
    this.form.companyEmail = '';
    this.form.companyPassword = '';
    this.form.companyRePassword = '';
    this.form.companyCity = '';
    this.form.companyState = [];
    this.form.companyCountry = [];
    this.form.companyCodePostal = [];
    this.zoneCompany = [];
    this.form.companyEarningAccounts = '';
    this.form.companyprofitending = '';
    this.form.companylocalcurrency = '';
    this.form.companyTransactionalCurrency = '';
    this.form.companypercentprofitability = '';
    this.form.controlprofitability = false;
    this.form.edi = false;
    this.form.expirationlock = false;
    this.form.ean13 = false;
    this.form.courier = false;
    this.form.freight = false;
    this.form.wms = false;
    this.form.multicurrency = false;
    this.form.orderlock = false;
    this.form.quotelock = false;
    this.form.useserial = false;
    (this.form.usezone = false), (this.form.virtualLocker = false);
    this.form.purchasesinshipments = false;
    this.form.companyclosingperiod = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
    this.form.dropCompanySetting = '';
    this.$nextTick(() => this.$refs.firstStep.reset());
    this.$nextTick(() => this.$refs.twoStep.reset());
    this.$refs.companyId.focus();
  }

  executeMigrated() {
    this.isLoading = true;
    this.migrations
      .execute(this.countryCode.toUpperCase())
      .then(() => {
        showAlert('info', 'Successful Migration');
      })
      .catch(() => {
        showAlert('error', 'Error Migration');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async findPricingZones() {
    try {
      this.isLoading = true;
      const res = await this.findAllPricingZones.execute();
      this.zonesList = res.length > 0 ? res : [];
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }
}
